"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolatilityType = exports.VolatilityTermStructureType = exports.QuoteFallbackLogic = exports.DividendType = exports.CreditSpreadType = exports.QuotationMode = exports.RoundingType = exports.Rounding = exports.ProjectedIndexCalculationMethod = exports.BenchmarkYieldSelectionMode = exports.YieldType = exports.RedemptionDateType = exports.StubRule = exports.AdjustInterest = exports.IndexObservationMethod = exports.IndexCalculationMethod = exports.PaymentFrequency = exports.InterestType = exports.Direction = exports.Outputs = exports.InflationMode = exports.PriceSide = exports.PaymentRollConvention = exports.DayCountBasisConvention = exports.BusinessDayConvention = void 0;
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "BusinessDayConvention", { enumerable: true, get: function () { return financial_contracts_1.BusinessDayConvention; } });
Object.defineProperty(exports, "DayCountBasisConvention", { enumerable: true, get: function () { return financial_contracts_1.DayCountBasisConvention; } });
Object.defineProperty(exports, "PaymentRollConvention", { enumerable: true, get: function () { return financial_contracts_1.PaymentRollConvention; } });
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return financial_contracts_1.PriceSide; } });
Object.defineProperty(exports, "InflationMode", { enumerable: true, get: function () { return financial_contracts_1.InflationMode; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
Object.defineProperty(exports, "Direction", { enumerable: true, get: function () { return financial_contracts_1.Direction; } });
Object.defineProperty(exports, "InterestType", { enumerable: true, get: function () { return financial_contracts_1.InterestType; } });
Object.defineProperty(exports, "PaymentFrequency", { enumerable: true, get: function () { return financial_contracts_1.PaymentFrequency; } });
Object.defineProperty(exports, "IndexCalculationMethod", { enumerable: true, get: function () { return financial_contracts_1.IndexCalculationMethod; } });
Object.defineProperty(exports, "IndexObservationMethod", { enumerable: true, get: function () { return financial_contracts_1.IndexObservationMethod; } });
Object.defineProperty(exports, "AdjustInterest", { enumerable: true, get: function () { return financial_contracts_1.AdjustInterest; } });
Object.defineProperty(exports, "StubRule", { enumerable: true, get: function () { return financial_contracts_1.StubRule; } });
var RedemptionDateType;
(function (RedemptionDateType) {
    RedemptionDateType["RedemptionAtMaturityDate"] = "RedemptionAtMaturityDate";
    RedemptionDateType["RedemptionAtCallDate"] = "RedemptionAtCallDate";
    RedemptionDateType["RedemptionAtPutDate"] = "RedemptionAtPutDate";
    RedemptionDateType["RedemptionAtWorstDate"] = "RedemptionAtWorstDate";
    RedemptionDateType["RedemptionAtBestDate"] = "RedemptionAtBestDate";
    RedemptionDateType["RedemptionAtSinkDate"] = "RedemptionAtSinkDate";
    RedemptionDateType["RedemptionAtParDate"] = "RedemptionAtParDate";
    RedemptionDateType["RedemptionAtPremiumDate"] = "RedemptionAtPremiumDate";
    RedemptionDateType["RedemptionAtMakeWholeCallDate"] = "RedemptionAtMakeWholeCallDate";
    RedemptionDateType["RedemptionAtCustomDate"] = "RedemptionAtCustomDate";
    RedemptionDateType["RedemptionAtPerpetuity"] = "RedemptionAtPerpetuity";
    RedemptionDateType["RedemptionAtAverageLife"] = "RedemptionAtAverageLife";
    RedemptionDateType["RedemptionAtPartialCallDate"] = "RedemptionAtPartialCallDate";
    RedemptionDateType["RedemptionAtPartialPutDate"] = "RedemptionAtPartialPutDate";
    RedemptionDateType["RedemptionAtNextDate"] = "RedemptionAtNextDate";
    RedemptionDateType["NativeRedemptionDate"] = "NativeRedemptionDate ";
})(RedemptionDateType || (exports.RedemptionDateType = RedemptionDateType = {}));
var YieldType;
(function (YieldType) {
    YieldType["Native"] = "Native";
    YieldType["UsGovt"] = "UsGovt";
    YieldType["UsTBills"] = "UsTBills";
    YieldType["Isma"] = "Isma";
    YieldType["Euroland"] = "Euroland";
    YieldType["Discount_Actual_360"] = "Discount_Actual_360";
    YieldType["Discount_Actual_365"] = "Discount_Actual_365";
    YieldType["MoneyMarket_Actual_360"] = "MoneyMarket_Actual_360";
    YieldType["MoneyMarket_Actual_365"] = "MoneyMarket_Actual_365";
    YieldType["MoneyMarket_Actual_Actual"] = "MoneyMarket_Actual_Actual";
    YieldType["Bond_Actual_364"] = "Bond_Actual_364";
    YieldType["Japanese_Simple"] = "Japanese_Simple";
    YieldType["Japanese_Compounded"] = "Japanese_Compounded";
    YieldType["Moosmueller"] = "Moosmueller";
    YieldType["Braess_Fangmeyer"] = "Braess_Fangmeyer";
    YieldType["Weekend"] = "Weekend";
    YieldType["TurkishCompounded"] = "TurkishCompounded";
    YieldType["Annual_Equivalent"] = "Annual_Equivalent";
    YieldType["Semiannual_Equivalent"] = "Semiannual_Equivalent";
    YieldType["Quarterly_Equivalent"] = "Quarterly_Equivalent";
    YieldType["MarketReference"] = "MarketReference";
})(YieldType || (exports.YieldType = YieldType = {}));
var BenchmarkYieldSelectionMode;
(function (BenchmarkYieldSelectionMode) {
    BenchmarkYieldSelectionMode["Nearest"] = "Nearest";
    BenchmarkYieldSelectionMode["Interpolate"] = "Interpolate";
})(BenchmarkYieldSelectionMode || (exports.BenchmarkYieldSelectionMode = BenchmarkYieldSelectionMode = {}));
var ProjectedIndexCalculationMethod;
(function (ProjectedIndexCalculationMethod) {
    ProjectedIndexCalculationMethod["ConstantIndex"] = "ConstantIndex";
    ProjectedIndexCalculationMethod["ForwardIndex"] = "ForwardIndex";
    ProjectedIndexCalculationMethod["ConstantCouponPayment"] = "ConstantCouponPayment";
})(ProjectedIndexCalculationMethod || (exports.ProjectedIndexCalculationMethod = ProjectedIndexCalculationMethod = {}));
var Rounding;
(function (Rounding) {
    Rounding["Zero"] = "Zero";
    Rounding["One"] = "One";
    Rounding["Two"] = "Two";
    Rounding["Three"] = "Three";
    Rounding["Four"] = "Four";
    Rounding["Five"] = "Five";
    Rounding["Six"] = "Six";
    Rounding["Seven"] = "Seven";
    Rounding["Eight"] = "Eight";
    Rounding["Default"] = "Default";
    Rounding["Unrounded"] = "Unrounded";
})(Rounding || (exports.Rounding = Rounding = {}));
var RoundingType;
(function (RoundingType) {
    RoundingType["Default"] = "Default";
    RoundingType["Near"] = "Near";
    RoundingType["Up"] = "Up";
    RoundingType["Down"] = "Down";
    RoundingType["Floor"] = "Floor";
    RoundingType["Ceil"] = "Ceil";
    RoundingType["FaceNear"] = "FaceNear";
    RoundingType["FaceDown"] = "FaceDown";
    RoundingType["FaceUp"] = "FaceUp";
})(RoundingType || (exports.RoundingType = RoundingType = {}));
var QuotationMode;
(function (QuotationMode) {
    QuotationMode["Unknown"] = "Unknown";
    QuotationMode["CashCleanPrice"] = "CashCleanPrice";
    QuotationMode["CashGrossPrice"] = "CashGrossPrice";
    QuotationMode["PercentCleanPrice"] = "PercentCleanPrice";
    QuotationMode["PercentGrossPrice"] = "PercentGrossPrice";
    QuotationMode["Yield"] = "Yield";
    QuotationMode["MoneyMarketYield"] = "MoneyMarketYield";
    QuotationMode["Discount"] = "Discount";
    QuotationMode["Spread"] = "Spread";
    QuotationMode["SimpleMargin"] = "SimpleMargin";
    QuotationMode["DiscountMargin"] = "DiscountMargin";
})(QuotationMode || (exports.QuotationMode = QuotationMode = {}));
var CreditSpreadType;
(function (CreditSpreadType) {
    CreditSpreadType["FlatSpread"] = "FlatSpread";
    CreditSpreadType["TermStructure"] = "TermStructure";
})(CreditSpreadType || (exports.CreditSpreadType = CreditSpreadType = {}));
var DividendType;
(function (DividendType) {
    DividendType["None"] = "None";
    DividendType["ForecastTable"] = "ForecastTable";
    DividendType["HistoricalYield"] = "HistoricalYield";
    DividendType["ForecastYield"] = "ForecastYield";
    DividendType["ImpliedYield"] = "ImpliedYield";
    DividendType["ImpliedTable"] = "ImpliedTable";
    DividendType["Futures"] = "Futures";
})(DividendType || (exports.DividendType = DividendType = {}));
var QuoteFallbackLogic;
(function (QuoteFallbackLogic) {
    QuoteFallbackLogic["None"] = "None";
    QuoteFallbackLogic["BestField"] = "BestField";
})(QuoteFallbackLogic || (exports.QuoteFallbackLogic = QuoteFallbackLogic = {}));
var VolatilityTermStructureType;
(function (VolatilityTermStructureType) {
    VolatilityTermStructureType["Historical"] = "Historical";
    VolatilityTermStructureType["Implied"] = "Implied";
})(VolatilityTermStructureType || (exports.VolatilityTermStructureType = VolatilityTermStructureType = {}));
var VolatilityType;
(function (VolatilityType) {
    VolatilityType["Flat"] = "Flat";
    VolatilityType["TermStructure"] = "TermStructure";
})(VolatilityType || (exports.VolatilityType = VolatilityType = {}));
